import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ImageDownloadMedia } from "../model/mediaService";
import brokenImage2 from "../images/brokenImage2.jpg";
import { saveFloorImageMapping } from "../store/actions";

const FloorImageHoc = (Component, cameraId, eventCheck, tagids, unresolvedEventData) => {
  const [imageLoading, setImageLoading] = useState(true);
  const [floorImage, setFloorImage] = useState();
  const sitesTagList = useSelector((state) => state.sitesReducer.siteTagList);
  const { activeSession } = useSelector(
    (state) => state.sessionReducer.activeSession
  );
  const floors = sitesTagList?.floors;
  const dispatch = useDispatch();
  const cachedFloorImages = useSelector(
    (state) => state?.imagesReducer?.floorImages
  );

  const fetchImageUrl = async () => {
    const tagList = [tagids];
    const floorsList = getFloor(tagList);
    if (floorsList && Object?.keys(floorsList)?.length > 0) {
      const fid = floorsList.id || {};
      const imageId = floorsList.imageid;
      const matchingFloorImageTag = cachedFloorImages?.find(
        (floor) => floor.id === fid
      );
      if (!matchingFloorImageTag) {
        try {
          setImageLoading(true);
          const url = await ImageDownloadMedia(imageId, activeSession);
          dispatch(saveFloorImageMapping(fid, url));
          setFloorImage(url);
        } catch (error) {
          console.error("Error downloading image:", error);
          setFloorImage(brokenImage2);
        } finally {
          setImageLoading(false);
        }
      } else {
        setFloorImage(matchingFloorImageTag.imageUrl);
        setImageLoading(false);
      }
    } else if (floors !== undefined) {
      // floors is [] — loaded but no floors configured for this site
      setFloorImage(brokenImage2);
      setImageLoading(false);
    }
    // floors undefined = siteTagList still loading (page refresh) — wait for next run
  };

  const getFloor = (tagList) => {
    if (!tagList || !floors) return null;

    for (const id of tagList) {
      const floor = floors.find((f) => f?.id === id);
      if (floor) return floor;
    }

    return null;
  };

  useEffect(() => {
    const fetchData = async () => {
      await fetchImageUrl();
    };

    fetchData();
  }, [tagids, cameraId, floors]);

  return (props) => {
    return (
      <Component
        {...props}
        compData={{
          cameraId,
          floorPlanImage: floorImage,
          eventCheck,
          imageLoading,
          unresolvedEventData,
        }}
      />
    );
  };
};

export default FloorImageHoc;
